<template>
  <div>
    <loading :active.sync="isLoading"
        :is-full-page="fullPage"></loading>
    <div v-show="showPopup" style="position: absolute; width: 100%; z-index: 10000; height: 100vh; background-color: rgba(0, 0, 0, 0.7);">
      <div class="popup-location">
        <img src="./../assets/channels/no-gps.png">
        <div class="popup-location-title">ACTIVAR UBICACIÓN GPS</div>
        <div class="popup-location-content">
          Por favor, para continuar activa tu ubicación GPS que usa el servicio de Google.
        </div>
        <button class="popup-location-button"  @click="hiddenPopup()">Entendido</button>
      </div>
    </div>
    <gmap-map
      :center="center"
      :zoom="16"
      :icon="{ url: require('./../assets/channels/1-1.png')}"
      style="width:100%;  height: 100vh; z-index: 999"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :icon="getMarkers(m.id)"
        :clickable="true"
        @click="clickDetail(m, index)"
      ></gmap-marker>
      <gmap-info-window
        :options="infoOptions"
        :position="infoPosition"
        :opened="infoOpened"
        @closeclick="infoOpened=false"
      >
        <div class="iw-content" style="width: auto;">
          <div class="info-title">
            {{chooseStaff.department}}
          </div>
          <div class="info-hr"></div>
          <div class="info-content">
            <div class="info-block">
              <div class="info-block-title">Servicios Bitel:</div>
              <div class="info-block-content" style="padding-top: 0;">
                <div v-if="chooseStaff.is_recharge" style="padding-top: 4px">
                  <img src="./../assets/channels/path-2.png" style="margin-top: -3px">
                  <span>Realizar recargas</span>
                </div>
                <div v-if="chooseStaff.is_recharge_receipts" style="padding-top: 4px">
                  <img src="./../assets/channels/path-2.png" style="margin-top: -3px">
                  <span>Pago de recibos</span>
                </div>
                <div v-if="chooseStaff.is_center_of_attention" style="padding-top: 4px">
                  <img src="./../assets/channels/path-2.png" style="margin-top: -3px">
                  <span>Obtener plan control</span>
                </div>
              </div>
            </div>
            <div class="info-block">
              <div class="info-block-title">Dirección:</div>
              <div class="info-block-content">
                <a
                        :href="'https://www.google.com/maps/dir/'+defaultLocation.lat+','+defaultLocation.lng+'/'+chooseStaff.position.lat+','+chooseStaff.position.lng"
                        target="_blank">
                  {{chooseStaff.code}}
                </a>
              </div>
            </div>
            <div class="info-block">
              <div class="info-block-title">Horario de Atención:</div>
              <div class="info-block-content">{{chooseStaff.workTime}}</div>
            </div>
          </div>
        </div>
      </gmap-info-window>
    </gmap-map>
    <div>
        <img
          src="./../assets/channels/current.png"
          class="get-location"
          @click="geolocate()"
        >
    </div>
    <sidebar :pos="markersPos"></sidebar>
  </div>
</template>

<script>
  import { getAllPos } from '../services/MapServices'
  import Sidebar from "./Sidebar";
  import { EventBus } from '../config/EventBus'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    name: "GoogleMap",
    components: {Sidebar, Loading},
    data() {
          return {
            center: { lat: -12.097038, lng: -77.01598 },
            defaultLocation: { lat: -12.097038, lng: -77.01598 },
            centerIcon: { url: require('./../assets/channels/1-1.png')},
            markers: [],
            markersPos: [],
            places: [],
            currentPlace: null,
            infoPosition: {
              lat: null,
              lng: null
            },
            infoContent: null,
            infoOpened: false,
            infoOptions: {
              pixelOffset: {
                width: 0,
                height: -35,
                left: 10
              }
            },
            chooseStaff: {
              name: null,
              code: null,
              position: {
                lat: null,
                lng: null,
              },
              workTime: null,
              is_recharge: false,
              is_recharge_receipts: false,
              is_center_of_attention: false,
            },
            showPopup: false,
            selectedKey: null,
            isLoading: false,
            fullPage: true,
            mapMarker:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAiCAYAAABMfblJAAAAAXNSR0IArs4c6QAAA59JREFUSA2tV1tIlEEU/s6/uxqKbtIFeog2uu4KvvQQFEJBlhFZUUYRQUI3qCAkkgjqxYeoHooegoQegsBYCqGsVbqATyH0kIEmXbCngixT1jJd/9OZWf/8d/1v1g4sc+ac75xvzsyZmX8JPo3f1pWBxzbARI1Aq0FcAVCJyMXyGwD4NZh6UExttLzjveg8G7lZ+d3WcmQyTTDpNIMVgWcjAstE2sHGNapMPXMDOxLy2y0NMM0rzJjn5uilJ6LbKIuepMXJX/m4GYTcu7mZmc/nA2c7lozfIFy0k1a2f7T75hByb02LZHXYDvgfWTLtR3F0LS1LDltxDEtQy1hIMhVXVmoVxoZbmetDFo8m5L7aGEy+bikL2UvB1aJ35IgVM5shm5dkNmWWsuA98VkrS4P7dqlK3FlwEltASWYp+of3KVUY5ugBSVsdYv9WvgGIbgLmxIDxL0D6JfDtgfiZ/r4mtgvobhiEjerI+rZFjaCK2mlYZCFQWgUuqwY+nZEKmZi2OUmMNUptCFnMyZ6jk8xyyGxGKokDCw7ZNC4i8TL+UB+VouGYC2RarZbRq831sYuvHDmCmZ4vhFTkFUvb1J55NArLfR4q90BMmcI0asjt/9UXqQrEo/HkKDA54oGYMpWWplWG/b5IVY1eLd3tZdU2ueY+08KkJnzui5bS5599jjDOfAe+3HS05SkfqbGBItwXdp+DJGYpfR5MgjNDOo5aRh5+AXw4Lsv5Iy+2w5DwUGn1ayFPUpvcBjscYM4qVSBB9mzKW78a8WgVUXI8e5eGI+dE+ds5uoN2FmRZbzqpyJSsCeWRlA2iiw6h/1slibRSouOpFSiboRrFU5fF2GYZCtHLfvUhEjpmj/WXUMgY86MH9aeBHfGPMoGGUGzU0YonOQf0L6GKq84JKFQnpIP/yKPdJLMMiPY6fTbmEGrSeGpAqHeLk8/17zElgxrt+2ZHziDUpInOLhjGCTswqCxb00LxzhtueEdCTRrvaJF9cHV0CihkXYjHPCfqSqgDJtY1yn66fkXbSYVsQCpyD9Etz63QN43dMV/mT9sqkJ7ols+Q5fk2ayxB0giF1tPqVI+lc+u9MxQvWtI+hEhEKpdyytsKKCsgTysdDEKmfHwJFSh7Exn7hdThkqcLlOgMfGEEItSkidRjyaVJyVaTCdwTsmZrHKQPTKiCUWXnVSG5o2WiV/IPqSEIiR0Ttg8CyZHQUZqYLJeKPOX0d8wvxh/yfQWr9AI9ZQAAAABJRU5ErkJggg==",
            mapMarkerActive:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAiCAYAAABMfblJAAAAAXNSR0IArs4c6QAAA6VJREFUSA21V01oVFcU/s7LpONPkzpGiqiFKakUtNSFgqIJKEzMSDGmqEUpggGti7oQDYoIdtNFqS4qQhcNdFEQ1CAEbHCSjBaiBQ24UKEhIJquAkZMIhlifpzrdyZ5kzfmvfsmJjmB3HvP+c73zb3nvDtvBCF2r86UZd5gezaLGhFUG4MYBEuYFoVBL32PxOCxKUFLsk2ehtAxNcDu7zLlgxM4Y4ATJFYBq5GIULQ6gt92dsjtILCvYCphGphwgQwVQYk2P0n/LI/h+NZmGXkfN0MwtdP8bLI49z7wA9ZPSqOoT7TKM29ugWCqxjSxRke8gLnMSd5TAmyuScuQy+O4Ez3G+RRTXpbky7fAVbOfLTVlOcFbSRNn8JLrnM+RvMm2QRx1OXOCMoFf6ChznQswnnZ36aS/NRVGUL8AInlKlurz9iEcUEdkPIPvedjRfNQyWbkdWF0DfBwHRvqAFw+A/2+wVllL0lSImN2cXolIFjt4zqH21SlgTXIatvhTYPkGYGUV0NUIZMenY74zwUb1O7xr4r4Aj1N35hXzhLBsHbD2sNcTMDeo7EiYTxweZzwAknfrMdpsVUhcc3mK4pRihcOG+chGpjGtmc2iMaC03IaYjPGezegO+8Og2iA2m8gA469tiKnYUgxrDXvCoNqNNuvvskUnY/wa69vRLMPcJe6EwbX1B//zR42+Arp/948VeAV/69rh3w3u0vok6XOmrf/8OjA6MEmjx9j3D/DvMWBssIDad8GN3dQAR4AXdwu7aI/OizFtkKJqNkVGkZ7PYvh6fbOM5e5SXuVnKT1ajJhiZiOW4yzBcRXTeU6Q31fd/BQ/5YLz/U9wle86aZc2J6iL2nb8StEWNzAfIzuzOxYBqzxteUERMXyADzH0ZDo8h5lggOdXt+WWFDyheUGl1ucEEdRx+nIOUtqJE+LgO7/XxgJBFdmVkl7HwV4mhd3/gZ+JYie9dfMCZwhqsLZdOjn86AUWO6dYE/MvB+F9BRWcTEsTh8BEP0I2SeeKuP2DBgoq4aIqnGRBAt+ivaIU610Swb5Nf4i1FCyV3e5+Y2KZMXTxveSLICRJhiMRbEuk5HEQxvVbd6ig6lYZKDHsXEFBe7sEFDOs26FixDQnVFBBehPx+jtI0RmXvHFwnk1S9IUReqQq6FpbwjRS8YK7ZvI1Nlfu9c/1hY1F7dAlqU3LRYr8pWs2yUP+QmpwY8WOsxJU0spS/EDRlmgE9X4/x8KE3wEY0fCb6Z33QgAAAABJRU5ErkJggg==",
            mapMarkerCenter:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAwCAMAAAChW0MZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABdFBMVEX/UFD////kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7kPj7lPj7qQkLuRETwRkbxRkbtRET3Skr+T0//UFD3S0vuRUX8Tk7mPz/4S0vpQUH7Tk7nQED9T0/5TEzvRUXlPz/+UFDxR0foQUHzSEjoQEDvRkb1SUn1Skr2SkryR0frQ0P7TU3pQkIAAADQb4oJAAAAWHRSTlMAAAALTY684vAvovMfrv5l9WYEngWja20l9/gmuDusqxL5E1iYxOf8/e/W17B5ejUB3HcO7m4Dx+03QfEt2gyVMeGvFc0j03M+2aVLG7n7KJFG7BBpHn1CUhRzBQAAAAFiS0dEe0/StfwAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQfhBwoXADYagn6fAAACCklEQVQ4y43UiVPaQBgF8M/1QgWaItYe2taztNqqqGjBq1pttdr7eEaELERABVFrq/jXdwOmBEg2vpnMZL/8JpPJ7D4iS5pbWtvaPfC0t7W2NN/MmoxYTEdnF6rp6uywUV6fXzzbVffi+/E9dVfc+33eenVHEfNEUuOVaKmEWCt3a1SgW8zSOrdGT4tZd6Cqgj7gIMPrkzkAfMH/qgfI5nhjclmgx1T3AFXjdtFUoLei7j/A4RG3z9EhHj4qqz7gmDvlGOgzVD+Q587JA/1CPUZBlyi9gCdN9HQAaS5LGgODNARkpCoDDNEwCidSdVLAMI1A5fKoGKFRl88yPmyUFMRdVBwKPcO+iyoiRM9v8S4PvUDCRSUwRuM4dVGnGKeXgC5FOvCKJoAzqToDJmhyClmpymJqkigMJCUoCYTFzpmewbnmiLRzzEwbe7UXkl/2G5gt7+jIHHDhgC6AuUjlDHnngT+26C8w7zXP42tx/C9t0KUogWi1AaIx4KpUZ0pXQCxqbZOFRdE3easr5UXvLC7Uds7SckiUx3UxldO4lksVr8UqtLzU0HIrb1AT/+qKXReuxazo7bp9Y9KsBXnWHHqVAhtV9Y5qlLiYmfd+E20GzVmjYlum+sAkavumy3eYTLFwGX38JFfBMUN9ZnLFvgj09ZubYqvAd+aqfigbAXfFfv5it1AR1qj+AQXZohV1IOcYAAAAAElFTkSuQmCC",
          };
      },

      mounted() {
          this.geolocate()
          this.getAllPosByLocaltion(this.center.lat, this.center.lng);
          EventBus.$on('posDetail', marker => {
            this.clickDetail(marker, marker.id)
          });
      },

      methods: {
        setPlace(place) {
          this.currentPlace = place;
        },
        addMarker() {
            if (this.currentPlace) {
                const marker = {
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng()
                };
                this.markers.push({ position: marker });
                this.places.push(this.currentPlace);
                this.center = marker;
                this.currentPlace = null;
            }
        },
        geolocate: function() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.showPopup = false;
            }, error => {
              this.showPopup = true;
              if(error.code === 1) {
                this.center =  { lat: -12.097038, lng: -77.01598 };
              }
            })
        },
        getAllPosByLocaltion(lat, lng) {
            this.isLoading = true;
            if(!this.checkSessionStorage()) {
              var params = {
                x: lat,
                y: lng,
                distance: 3
              }
              getAllPos(params).then((response) => {
                var posInfo = []
                response.data.records.map(function (record, index){
                  const marker = {
                    lat: record.x,
                    lng: record.y
                  };
                  posInfo.push({
                    id: index,
                    position: marker ,
                    code: record.description,
                    worktime: record.worktime,
                    department: record.department,
                    is_recharge: record.is_recharge,
                    is_recharge_receipts: record.is_recharge_receipts,
                    is_center_of_attention: record.is_center_of_attention
                  });
                });
                sessionStorage.setItem('pos_info', JSON.stringify(posInfo))
                this.markers = posInfo
                this.markers.push({
                  id: 'center',
                  position: this.center ,
                  code: null,
                  worktime: null,
                  is_recharge: null,
                  is_recharge_receipts: null,
                  is_center_of_attention: null
                })
                this.markersPos = posInfo
                setTimeout(() => {
                  this.isLoading = false
                },2500)
              })
            } else {
              this.markers = JSON.parse(sessionStorage.getItem('pos_info'))
              this.markersPos = this.markers.splice(1)
              setTimeout(() => {
                  this.isLoading = false
                },2500)
            }
        },
        checkSessionStorage() {
            var center = JSON.stringify(this.center);
            var sessionCenter = sessionStorage.getItem("center");
            if(sessionStorage.getItem("pos_info") != null && center != sessionCenter) {
              return true;
            } else {
              return false;
            }
        },
        clickDetail(marker, key) {
          this.center = marker.position;
          this.infoOpened = true;
          this.infoPosition = marker.position;
          this.chooseStaff = marker;
          this.selectedKey = key;
        },
        hiddenPopup() {
          this.showPopup = false;
          this.center =  { lat: -12.097038, lng: -77.01598 };
          sessionStorage.setItem('center', JSON.stringify(this.center))
        },
        getMarkers(key) {
          if (this.selectedKey === key) return this.mapMarkerActive;
          if (key === 'center') return this.mapMarkerCenter;
          return this.mapMarker;
        },
      }
  };
</script>
<style>
    body {
      /* font: 14px/16px "Roboto", sans-serif; */
      margin: 0px;
    }
    .gm-svpc, .gm-style-mtc {
        display: none;
    }
    .get-location {
        width: 40px;
        height: 40px;
        position: absolute;
        cursor: pointer;
        right: 10px;
        bottom: 120px;
        z-index: 1000;
    }
    .popup-location {
      text-align: center;
      margin: auto;
      margin-top: 86px;
      padding-top: 30px;
      width: 320px;
      height: 270px;
      border-radius: 4px;
      background-color: #ffffff;
      z-index: 10001;
    }
    .popup-location-title {
      margin-top: 25px;
      font: 14px/16px "Roboto", sans-serif;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.07;
      letter-spacing: normal;
      color: #333333;
    }
    .popup-location-content {
      font: 14px/16px "Roboto", sans-serif;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: center;
      color: #333333;
      margin-left: 30px;
      margin-right: 30px;
      margin-top: 21px;
      margin-bottom: 31px;
    }
    .popup-location-button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      background-color: #00a5b1;
      font: 14px/16px "Roboto", sans-serif;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.08;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .info-title {
      font: 14px/16px "Roboto", sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.07;
      letter-spacing: normal;
      color: #4cb9ca;
      padding: 18px;
    }
    .info-hr {
      height: 1px;
      border: dashed 1px #dddddd;
    }
    .info-content {
      margin-left: 23px;
      margin-right: 23px;
      margin-bottom: 18px;
    }
    .info-block {
      margin-top: 10px;
      font: 14px/16px "Roboto", sans-serif;
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
    }
    .info-block-title {
      font-weight: bold;
      color: #333333;
    }
    .info-block-content {
      margin-top: 4px;
      color: #4c5f71;
    }
    .gm-ui-hover-effect {
      background: #00a5b1 !important;
      top: 20px !important;
      right: 15px !important;
      border-radius: 50%;
      outline: none;
    }
</style>